import { render, staticRenderFns } from "./modalHelpProyectos.vue?vue&type=template&id=66180a98&scoped=true&"
import script from "./modalHelpProyectos.vue?vue&type=script&lang=js&"
export * from "./modalHelpProyectos.vue?vue&type=script&lang=js&"
import style0 from "./modalHelpProyectos.vue?vue&type=style&index=0&id=66180a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66180a98",
  null
  
)

export default component.exports